/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StepRecipeModal_summaryIngredient$ref: FragmentReference;
declare export opaque type StepRecipeModal_summaryIngredient$fragmentType: StepRecipeModal_summaryIngredient$ref;
export type StepRecipeModal_summaryIngredient = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +ingredient: {|
        +id: string,
        +name: string,
      |}
    |}
  |}>,
  +$refType: StepRecipeModal_summaryIngredient$ref,
|};
export type StepRecipeModal_summaryIngredient$data = StepRecipeModal_summaryIngredient;
export type StepRecipeModal_summaryIngredient$key = {
  +$data?: StepRecipeModal_summaryIngredient$data,
  +$fragmentRefs: StepRecipeModal_summaryIngredient$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StepRecipeModal_summaryIngredient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RecipeIngredientNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecipeIngredientNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IngredientNode",
              "kind": "LinkedField",
              "name": "ingredient",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecipeIngredientNodeConnection"
};
// prettier-ignore
(node/*: any*/).hash = '4ed3cf3b3bc7d7721def5de6185b4742';

module.exports = node;
